import { AdimoCSModel } from './Adimo/models';
import { checkAdimoAvailable } from './Adimo/utils';
import { MikMakCSModel } from './MikMak/models';
import { checkMikMakV1Available, checkMikMakV2Available } from './MikMak/utils';
import { PriceSpiderCSModel } from './PriceSpider/models';
import { checkPriceSpiderAvailable } from './PriceSpider/utils';

export { default as Adimo } from './Adimo';
export { AdimoCSModel } from './Adimo/models';
export { default as BazaarVoice } from './BazaarVoice';
export { default as MikMak } from './MikMak';
export { MikMakCSModel } from './MikMak/models';
export { default as PriceSpider } from './PriceSpider';
export { PriceSpiderCSModel, PriceSpiderModel } from './PriceSpider/models';

export const check3rdPartyAvailability = (
  shoppablePlugin,
  priceSpider?: PriceSpiderCSModel,
  adimo?: AdimoCSModel,
  mikmak?: MikMakCSModel
) => {
  const isPriceSpiderAvailable = checkPriceSpiderAvailable(
    shoppablePlugin,
    priceSpider
  );
  const isAdimoAvailable = checkAdimoAvailable(shoppablePlugin, adimo);
  const isMikMakV1Available = checkMikMakV1Available(shoppablePlugin, mikmak);
  const isMikMakV2Available = checkMikMakV2Available(shoppablePlugin, mikmak);

  return {
    isPriceSpiderAvailable,
    isAdimoAvailable,
    isMikMakV1Available,
    isMikMakV2Available,
  };
};
